// const API_URL = process.env.REACT_APP_API_URL;

export const loginAdmin = async (data) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const registerAdmin = async (data) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/admin/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};
